// extracted by mini-css-extract-plugin
export default {"form":"AccountCodeForm_form","title":"AccountCodeForm_title","subtitle":"AccountCodeForm_subtitle","wrapper":"AccountCodeForm_wrapper","cta":"AccountCodeForm_cta"};